<template>
  <v-container grid-list-xl text-center>
    <v-layout wrap>
      <v-flex xs10 offset-xs1>
        <v-alert type="error">
          ページがありません。
        </v-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  mounted () {
    document.title = 'ページがありません | 株式会社ブイワン';
  }
};
</script>
